import { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isBrowser, isTablet } from 'react-device-detect';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import {
  Segment,
  Modal,
  Icon,
  Grid,
  Tab,
  Dropdown,
  Popup,
} from 'semantic-ui-react';

import {
  EmptyContainer,
  CustomTable,
  CustomSegment,
} from '../../../components';

import { isEmpty, compact } from '../../../utils/lodash';
import { getActivityStatus, getActivityType } from '../../../utils';

import {
  getOrgActivityStat,
  getOwnedActivitiesByUser,
  getInvitedActivitiesByUser,
} from '../../../store/actions';

import './organization.scss';

const options = (t) => [
  {
    key: 'Ongoing',
    text: <b>{t('activity_status.ongoing_activities')}</b>,
    value: 'ongoing',
  },
  {
    key: 'Completed',
    text: <b>{t('activity_status.completed_activities')}</b>,
    value: 'completed',
  },
  {
    key: 'All Activities',
    text: <b>{t('activity_status.all_activities')}</b>,
    value: 'all',
  },
];

const act_type_options = (t) => [
  {
    key: 'All',
    text: <b>{t('activity_type.all_types')}</b>,
    value: 'all',
  },
  {
    key: 'Single',
    text: <b>{t('activity_type.single')}</b>,
    value: 'single',
  },
  {
    key: 'Grant',
    text: <b>{t('activity_type.grant')}</b>,
    value: 'grant',
  },
  {
    key: 'Festival',
    text: <b>{t('activity_type.festival')}</b>,
    value: 'festival',
  },
  {
    key: 'Multi Activity',
    text: <b>{t('activity_type.multi_activity')}</b>,
    value: 'multi-activity',
  },
  {
    key: 'Linked',
    text: <b>{t('activity_type.linked')}</b>,
    value: 'linked',
  },
];

class ActivityListView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      filter: {
        owned: 'all',
        invited: 'all',
      },
      actType: {
        owned: 'all',
        invited: 'all',
      },
      currentPage: {
        owned: 1,
        invited: 1,
      },
    };
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  getActivityList(type, page = 1) {
    const {
      getOwnedActivitiesByUser,
      getInvitedActivitiesByUser,
      selectedUser,
    } = this.props;
    const { filter, actType } = this.state;

    if (type === 'owned') {
      getOwnedActivitiesByUser(
        'ownedProjectLoading',
        selectedUser.id,
        filter.owned,
        actType.owned,
        page
      );
    } else {
      getInvitedActivitiesByUser(
        'invitedProjectLoading',
        selectedUser.id,
        filter.invited,
        actType.invited,
        page
      );
    }
  }

  async setFilter(type, filterType, value) {
    await this.setState((preState, props) => {
      return {
        ...preState,
        [filterType]: { ...preState[filterType], [type]: value },
        currentPage: { ...preState.currentPage, [type]: 1 },
      };
    });
    this.getActivityList(type);
  }

  pageChange = async (type, page) => {
    await this.setState((state, props) => {
      return {
        ...state,
        currentPage: { ...state.currentPage, [type]: page },
      };
    });
    this.getActivityList(type, page);
  };

  resetFilters = () => {
    this.setState({
      filter: {
        owned: 'all',
        invited: 'all',
      },
      actType: {
        owned: 'all',
        invited: 'all',
      },
      currentPage: {
        owned: 1,
        invited: 1,
      },
    });
  };

  render() {
    const { modal, filter, actType } = this.state;
    const { t, selectedUser } = this.props;

    return (
      <div className="modal-section">
        <Modal
          trigger={
            <label className="org-trigger-actions">{selectedUser.name}</label>
          }
          size="large"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="user-activity"
        >
          <Modal.Header>
            {t('organisation.activities.user_activities_header', {
              user_name: selectedUser.name,
            })}
          </Modal.Header>
          <Modal.Content>
            <Grid.Row>
              {modal ? (
                <div className="tab-section">
                  <Tab
                    className="activity-tabs"
                    menu={{
                      secondary: true,
                      pointing: true,
                    }}
                    panes={[
                      {
                        menuItem: t('common.managed_activities'),
                        render: () => (
                          <Tab.Pane>
                            <CustomSegment
                              title=""
                              rightHeader={
                                <div className="activities-filter-container">
                                  <span className="activities-filter">
                                    {t('common.type')} &nbsp;
                                    <Dropdown
                                      direction="left"
                                      inline
                                      selectOnBlur={false}
                                      value={actType.owned}
                                      options={act_type_options(t)}
                                      onChange={(e, { value }) =>
                                        this.setFilter(
                                          'owned',
                                          'actType',
                                          value
                                        )
                                      }
                                    />
                                  </span>
                                  <span className="activities-filter">
                                    {t('organisation.activities.show_by')}{' '}
                                    &nbsp;
                                    <Dropdown
                                      direction="left"
                                      inline
                                      selectOnBlur={false}
                                      value={filter.owned}
                                      options={options(t)}
                                      onChange={(e, { value }) =>
                                        this.setFilter('owned', 'filter', value)
                                      }
                                    />
                                  </span>
                                </div>
                              }
                            >
                              <UsersOwnedActivities
                                selectedUser={selectedUser}
                                pageChange={(type, page) =>
                                  this.pageChange(type, page)
                                }
                                resetFilters={this.resetFilters}
                                {...this.state}
                                {...this.props}
                              />
                            </CustomSegment>
                          </Tab.Pane>
                        ),
                      },
                      {
                        menuItem: t('common.invited_activities'),
                        render: () => (
                          <Tab.Pane>
                            <CustomSegment
                              title=""
                              rightHeader={
                                <div className="activities-filter-container">
                                  <span className="activities-filter">
                                    {t('common.type')} &nbsp;
                                    <Dropdown
                                      direction="left"
                                      inline
                                      selectOnBlur={false}
                                      value={actType.invited}
                                      options={act_type_options(t)}
                                      onChange={(e, { value }) =>
                                        this.setFilter(
                                          'invited',
                                          'actType',
                                          value
                                        )
                                      }
                                    />
                                  </span>
                                  <span className="activities-filter">
                                    {t('organisation.activities.show_by')}{' '}
                                    &nbsp;
                                    <Dropdown
                                      direction="left"
                                      inline
                                      selectOnBlur={false}
                                      value={filter.invited}
                                      options={options(t)}
                                      onChange={(e, { value }) =>
                                        this.setFilter(
                                          'invited',
                                          'filter',
                                          value
                                        )
                                      }
                                    />
                                  </span>
                                </div>
                              }
                            >
                              <UsersInvitedActivities
                                selectedUser={selectedUser}
                                pageChange={(type, page) =>
                                  this.pageChange(type, page)
                                }
                                resetFilters={this.resetFilters}
                                {...this.state}
                                {...this.props}
                              />
                            </CustomSegment>
                          </Tab.Pane>
                        ),
                      },
                    ]}
                  />
                </div>
              ) : null}
            </Grid.Row>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class UsersOwnedActivities extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = props;
    this.state = {
      columns: [
        {
          width: 5,
          title: t('common.activity_name'),
          render: (data) => {
            return (
              <div className="activity-name">
                <div
                  className={`square activity-${getActivityStatus(
                    data.statusId
                  )}`}
                />
                {data.name ? data.name : ''}
              </div>
            );
          },
        },
        {
          width: 2,
          title: t('common.type'),
          render: (data) => {
            const actType = getActivityType(data);
            return actType.type;
          },
        },
        {
          width: 1,
          title: t('common.todo'),
          textAlign: 'center',
          render: (data) => {
            const { label, criticality } = data.notification;
            return !isEmpty(data.notification) ? (
              <Popup
                content={label}
                trigger={
                  <Icon
                    name="info circle"
                    color={criticality === 'HIGH' ? 'red' : 'orange'}
                  />
                }
              />
            ) : (
              '-'
            );
          },
        },
        {
          width: 3,
          title: t('common.date_created'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.createdDateTime));
          },
        },
        {
          width: 3,
          title: t('common.last_updated'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.lastEditedDateTime));
          },
        },
        {
          width: 2,

          render: (data) => {
            return (
              <div className="activity-actions">
                <Link to={`/activities/${data.id}/goal`} target="_blank">
                  <label className="activity-actions-warn">
                    {t('actions.enter_activity')}
                  </label>
                </Link>
              </div>
            );
          },
        },
      ],
    };
  }

  componentDidMount() {
    const { getOwnedActivitiesByUser, resetFilters, selectedUser } = this.props;
    resetFilters();
    getOwnedActivitiesByUser('ownedProjectLoading', selectedUser.id);
  }

  render() {
    const { columns } = this.state;
    const { t, currentPage } = this.props;
    const {
      userOwnedActivity,
      customLoading: { ownedProjectLoading },
    } = this.props.organization;

    return (
      <Segment className="content-segment" loading={ownedProjectLoading}>
        {userOwnedActivity.docs && userOwnedActivity.docs.length ? (
          <CustomTable
            header
            columns={compact(columns)}
            data={userOwnedActivity.docs}
            customClass="home-activity"
            pagination
            handlePaginationChange={(page) =>
              this.props.pageChange('owned', page)
            }
            page={currentPage.owned}
            noOfPages={userOwnedActivity.pages}
            keyExtractor={(item, index) => item.id}
          />
        ) : (
          <EmptyContainer msg={t('empty_message.no_activities')} />
        )}
      </Segment>
    );
  }
}

class UsersInvitedActivities extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = props;

    this.state = {
      columns: [
        {
          width: 4,
          title: t('common.activity_name'),
          render: (data) => {
            return (
              <div className="activity-name">
                <div
                  className={`square activity-${getActivityStatus(
                    data.statusId
                  )}`}
                />
                {data.name ? data.name : ''}
              </div>
            );
          },
        },
        {
          width: 1,
          title: t('common.type'),
          render: (data) => {
            const actType = getActivityType(data);
            return actType.type;
          },
        },
        {
          width: 1,
          title: t('common.todo'),
          textAlign: 'center',
          render: (data) => {
            const { label, criticality } = data.notification;
            return !isEmpty(data.notification) ? (
              <Popup
                content={label}
                trigger={
                  <Icon
                    name="info circle"
                    color={criticality === 'HIGH' ? 'red' : 'orange'}
                  />
                }
              />
            ) : (
              '-'
            );
          },
        },
        {
          width: 2,
          title: t('common.owner'),
          textAlign: 'left',
          render: (data) => {
            return data.owner.name ? data.owner.name : '';
          },
        },
        {
          width: 3,
          title: t('common.date_created'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.createdDateTime));
          },
        },
        {
          width: 3,
          title: t('common.last_updated'),
          render: (data) => {
            return new Intl.DateTimeFormat(i18n.language, {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            }).format(new Date(data.lastEditedDateTime));
          },
        },
        {
          width: 2,
          title: '',
          render: (data) => {
            return !isEmpty(data.members) ? (
              <div className="activity-actions">
                <Link to={`/activities/${data.id}/goal`} target="_blank">
                  <label className="activity-actions-warn">
                    {t('actions.enter_activity')}
                  </label>
                </Link>
              </div>
            ) : (
              <div className="activity-actions">-</div>
            );
          },
        },
      ],
    };
  }

  componentDidMount() {
    const { getInvitedActivitiesByUser, resetFilters, selectedUser } =
      this.props;
    resetFilters();
    getInvitedActivitiesByUser('invitedProjectLoading', selectedUser.id);
  }

  render() {
    const { columns } = this.state;
    const { t, currentPage } = this.props;
    const {
      userInvitedActivity,
      customLoading: { invitedProjectLoading },
    } = this.props.organization;

    return (
      <Segment className="content-segment" loading={invitedProjectLoading}>
        {userInvitedActivity.docs && userInvitedActivity.docs.length ? (
          <CustomTable
            header
            columns={compact(columns)}
            data={userInvitedActivity.docs}
            customClass="home-activity"
            pagination
            handlePaginationChange={(page) =>
              this.props.pageChange('invited', page)
            }
            page={currentPage.invited}
            noOfPages={userInvitedActivity.pages}
            keyExtractor={(item, index) => item.id}
          />
        ) : (
          <EmptyContainer msg={t('empty_message.no_activities')} />
        )}
      </Segment>
    );
  }
}

class OrganizationActivity extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = this.props;

    this.state = {
      parentHeaders: [
        {
          title: '',
          colSpan: '1',
          className: '',
        },
        {
          title: t('organisation.activities.managed'),
          colSpan: '6',
          className: 'table-bottom-border table-right-border',
        },
        {
          title: t('organisation.activities.invited'),
          colSpan: '2',
          className: 'table-bottom-border',
        },
      ],
    };
  }

  async componentDidMount() {
    const { auth, getOrgActivityStat } = this.props;
    if (!isEmpty(auth.user)) {
      await getOrgActivityStat();
    }
  }

  getColumns() {
    const { t } = this.props;

    return [
      {
        title: '',
        render: (data) => {
          return <ActivityListView selectedUser={data} {...this.props} />;
        },
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.in_development')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.unapproved;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.missed_green_light')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.passedGreenLight;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('common.active')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.approved;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.documentation_delayed')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.documentationDelay;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.ready_to_archive')}{' '}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.activityArchive;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.completed')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.closed;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
        className: 'table-right-border',
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.in_development')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.invitedUnapproved;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
      {
        title: (
          <div className="user-act-heading-container">
            <label className="user-act-heading-type">
              {t('activity_status.active')}
            </label>
          </div>
        ),
        render: (data) => {
          return data.stats.invitedApproved;
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
    ];
  }

  render() {
    const { t } = this.props;
    const {
      orgActivityStats,
      customLoading: { getOrgActivityStat },
    } = this.props.organization;
    const { parentHeaders } = this.state;

    return (
      <Segment className="content-segment" loading={getOrgActivityStat}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="org-table-container">
              {orgActivityStats && orgActivityStats.length ? (
                <CustomTable
                  parentHeaders={parentHeaders}
                  header
                  columns={this.getColumns()}
                  data={orgActivityStats}
                  customClass="user-activity"
                  keyExtractor={(item, index) => item.id}
                />
              ) : (
                <EmptyContainer
                  msg={t('organisation.activities.no_user_activities_yet')}
                />
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrgActivityStat,
      getOwnedActivitiesByUser,
      getInvitedActivitiesByUser,
    },
    dispatch
  );
};

OrganizationActivity = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationActivity);

ActivityListView = withTranslation()(ActivityListView);
UsersOwnedActivities = withTranslation()(UsersOwnedActivities);
UsersInvitedActivities = withTranslation()(UsersInvitedActivities);
OrganizationActivity = withTranslation()(OrganizationActivity);

export { OrganizationActivity };
